module.exports = __webpack_public_path__ + "img/success-img.8a034fab.png";